module.exports = __webpack_public_path__ + "static/media/whiteIcon.e2cbadbe.png";